export enum OfferType {
  Offer = 'offer',
  Deal = 'deal',
}
